import PerforamanceReportTypes from "./averageMonthlyPerformanceReport.types";

//*****************AVERAGE MONTHLY PERFORMANCE REPORT FETCH******************/
export const averageMonthlyPerformanceReportFetchStart = (
  averageMonthlyPerformanceReportList: any,
) => ({
  type: PerforamanceReportTypes.AVERAGE_MONTHLY_PERFORMANCE_REPORT_FETCH_START,
  payload: averageMonthlyPerformanceReportList,
});

export const averageMonthlyPerformanceReportFetchSuccess = (success: any) => ({
  type: PerforamanceReportTypes.AVERAGE_MONTHLY_PERFORMANCE_REPORT_FETCH_SUCCESS,
  payload: success,
});

export const averageMonthlyPerformanceReportFetchFailure = (failure: any) => ({
  type: PerforamanceReportTypes.AVERAGE_MONTHLY_PERFORMANCE_REPORT_FETCH_FAILURE,
  payload: failure,
});

export const averageMonthlyPerformanceReportFetchResetStart = () => ({
  type: PerforamanceReportTypes.AVERAGE_MONTHLY_PERFORMANCE_REPORT_FETCH_RESET_START,
});

export const averageMonthlyPerformanceReportFetchResponseChanged = () => ({
  type: PerforamanceReportTypes.AVERAGE_MONTHLY_PERFORMANCE_REPORT_FETCH_RESPONSE_CHANGED,
});

//*******AVERAGE MONTHLY PERFORMANCE REPORT EXPORT********* */
export const averageMonthlyPerformanceReportExportAllStart = (
  averageMonthlyPerformanceReportList: any,
) => ({
  type: PerforamanceReportTypes.AVERAGE_MONTHLY_PERFORMANCE_REPORT_EXPORT_START,
  payload: averageMonthlyPerformanceReportList,
});
export const averageMonthlyPerformanceReportExportAllSuccess = (
  success: any,
) => ({
  type: PerforamanceReportTypes.AVERAGE_MONTHLY_PERFORMANCE_REPORT_EXPORT_SUCCESS,
  payload: success,
});
export const averageMonthlyPerformanceReportExportAllFailure = (
  failure: any,
) => ({
  type: PerforamanceReportTypes.AVERAGE_MONTHLY_PERFORMANCE_REPORT_EXPORT_FAILURE,
  payload: failure,
});
export const averageMonthlyPerformanceReportExportAllReset = () => ({
  type: PerforamanceReportTypes.AVERAGE_MONTHLY_PERFORMANCE_REPORT_EXPORT_CHANGED,
});
export const averageMonthlyPerformanceReportExportAllChanged = () => ({
  type: PerforamanceReportTypes.AVERAGE_MONTHLY_PERFORMANCE_REPORT_EXPORT_RESET_START,
});
